export default __webpack_public_path__ + "445c863245db9ae8eebe1c55c9cf476c.png";